import axios from "axios";

export default {

    namespaced: true,

    state: {
        loanpaymentreport:[],
        loandefaultersreport:[],
        installmentsdue:[],
        dormantborrowers:[],
        teamperfomancereport:[],
        branchperfomancereport:[],
        dailydisbursementreport:[],
        monthlydisbursementreport:[],
        installmentinarrears:[],
        productperformancereport:[],
        balanceasat:[],
        categoryperformancereport:[],
        disbursementsummary:[],
        //an object - windows, dimension, rank_by, rows - not a list like the others
        disbursementdrivers:null,
    },



    getters: {

        loanpaymentreport(state){
            return state.loanpaymentreport;
        },
        loandefaultersreport(state){
            return state.loandefaultersreport;
        },
        installmentsdue(state){
            return state.installmentsdue;
        },
        dormantborrowers(state){
            return state.dormantborrowers;
        },
        teamperfomancereport(state){
            return state.teamperfomancereport;
        },
        branchperfomancereport(state){
            return state.branchperfomancereport;
        },
        dailydisbursementreport(state){
            return state.dailydisbursementreport;
        },
        monthlydisbursementreport(state){
            return state.monthlydisbursementreport;
        },
        installmentinarrears(state){
            return state.installmentinarrears;
        },

        productperformancereport(state){
            return state.productperformancereport;
        },
        balanceasat(state){
            return state.balanceasat;
        },
        categoryperformancereport(state){
            return state.categoryperformancereport;
        },
        disbursementsummary(state){
            return state.disbursementsummary;
        },
        disbursementdrivers(state){
            return state.disbursementdrivers;
        }

    },

    mutations: {

        SET_LOAN_PAYMENT_REPORT(state,data){
            return state.loanpaymentreport=data;
        },
        SET_LOAN_DEFAULTERS_REPORT(state,data){
            return state.loandefaultersreport=data;
        },
        SET_INSTALLMENTS_DUE(state,data){
            return state.installmentsdue=data;
        },
        SET_DORMANT_BORROWERS(state,data){
            return state.dormantborrowers=data;
        },
        SET_TEAM_PERFOMANCE_REPORT(state,data){
            return state.teamperfomancereport=data;
        },
        SET_BRANCH_PERFOMANCE_REPORT(state,data){
            return state.branchperfomancereport=data;
        },
        SET_DAILY_DISBURSEMENT_REPORT(state,data){
            return state.dailydisbursementreport=data;
        },
        SET_MONTHLY_DISBURSEMENT_REPORT(state,data){
            return state.monthlydisbursementreport=data;
        },
        SET_INSTALLMENT_IN_ARREARS(state,data){
            return state.installmentinarrears=data;
        },
        SET_PRODUCT_PERFORMANCE_REPORT(state,data){
            return state.productperformancereport=data;
        },
        SET_BALANCE_AS_AT(state,data){
            return state.balanceasat=data;
        },
        SET_CATEGORY_PERFORMANCE_REPORT(state,data){
            return state.categoryperformancereport=data;
        },
        SET_DISBURSEMENT_SUMMARY(state,data){
            return state.disbursementsummary=data;
        },
        SET_DISBURSEMENT_DRIVERS(state,data){
            return state.disbursementdrivers=data;
        }

    },

    actions: {
        //installmentinarrears
        async fetchinstallmentinarrears({ commit }, params) {
            await axios.get('/api/v1/loan-reports/installment-in-arrears', { params: params })
                .then(res => {
                    commit('SET_INSTALLMENT_IN_ARREARS', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })
            },
       async fetchmonthlydisbursementreport({ commit }, params) {
        await axios.get('/api/v1/loan-reports/monthlydisbursements', { params: params })
            .then(res => {
                commit('SET_MONTHLY_DISBURSEMENT_REPORT', res.data);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

       async fetchdailydisbursementreport({ commit }, params) {
        await axios.get('/api/v1/loan-reports/dailydisbursements', { params: params })
            .then(res => {
                commit('SET_DAILY_DISBURSEMENT_REPORT', res.data);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

       async fetchbranchperfomancereport({ commit }, params) {
        await axios.get('/api/v1/loan-reports/branchperfomance', { params: params })
            .then(res => {
                commit('SET_BRANCH_PERFOMANCE_REPORT', res.data);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

        async fetchproductperformancereport({ commit }, params) {
        await axios.get('/api/v1/loan-reports/productperformance', { params: params })
            .then(res => {
                commit('SET_PRODUCT_PERFORMANCE_REPORT', res.data);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

       async fetchteamperfomancereport({ commit }, params) {
        await axios.get('/api/v1/loan-reports/teamperfomance', { params: params })
            .then(res => {
                commit('SET_TEAM_PERFOMANCE_REPORT', res.data);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

       async fetchdormantborrowers({ commit }, params) {
        await axios.get('/api/v1/loan-reports/dormant-borrowers', { params: params })
            .then(res => {
                commit('SET_DORMANT_BORROWERS', res.data);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

        async fetchloanpaymentreport({ commit }, params) {

            await axios.get('/api/v1/loan-reports/paymentreport', { params: params })
                .then(res => {
                    commit('SET_LOAN_PAYMENT_REPORT', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },



        async fetchloandefaultersreport({ commit }, params) {

            await axios.get('/api/v1/loan-reports/defaultersreport', { params: params })
                .then(res => {
                    commit('SET_LOAN_DEFAULTERS_REPORT', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },
        async fetchinstallmentsdue({ commit }, params) {

            await axios.get('/api/v1/loan-reports/installments-due', { params: params })
                .then(res => {
                    commit('SET_INSTALLMENTS_DUE', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },
       

        async fetchbalanceasat({ commit }, params) {

            await axios.get('/api/v1/loan-reports/balance-as-at', { params: params })
                .then(res => {
                    commit('SET_BALANCE_AS_AT', res.data);
                }).catch(err => {
                    return Promise.reject(err);
                })

        },

        async fetchcategoryperformancereport({ commit }, params) {
        await axios.get('/api/v1/loan-reports/categoryperformance', { params: params })
            .then(res => {
                commit('SET_CATEGORY_PERFORMANCE_REPORT', res.data);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

        //unlike the reports above, this endpoint answers through the standard response
        //envelope, so the rows sit under res.data.data rather than being res.data itself.
        async fetchdisbursementsummary({ commit }, params) {
        await axios.get('/api/v1/loan-reports/disbursement-summary', { params: params })
            .then(res => {
                commit('SET_DISBURSEMENT_SUMMARY', res.data && res.data.data ? res.data.data : []);
            }).catch(err => {
                return Promise.reject(err);
            })
        },

        //also enveloped, but its data is an object carrying both windows, the ranking
        //that was applied and the rows - not a bare list. Cleared on failure so a refused
        //range does not leave the previous report on screen under the new filter chips.
        async fetchdisbursementdrivers({ commit }, params) {
        await axios.get('/api/v1/loan-reports/disbursement-drivers', { params: params })
            .then(res => {
                commit('SET_DISBURSEMENT_DRIVERS', res.data && res.data.data ? res.data.data : null);
            }).catch(err => {
                commit('SET_DISBURSEMENT_DRIVERS', null);
                return Promise.reject(err);
            })
        },



    }

}
